type StepTitleProps = {
  subtitle: string;
  title?: string;
  className?: string;
};
export const StepTitle: React.FC<StepTitleProps> = ({
  className,
  subtitle,
  title,
}) => {
  return (
    <div className={className}>
      {title ? <div className="tw-titre-principal-carrot">{title}</div> : <></>}
      <div className="tw-titre-principal-spirit">{subtitle}</div>
    </div>
  );
};
